/**
 * Document Sign — per-user arche settings.
 *
 * Stored client-side via `useArcheSettings` (localStorage, per browser — the
 * same mechanism contact-book / calendar use). These are convenience defaults;
 * a synced account profile is a separate, future effort.
 */

export const DOCUMENT_SIGN_ARCHE_ID = 'arche_document_sign';

export interface DocumentSignSettings {
  /** Name pre-filled when the owner self-fills a recipient row. */
  defaultDisplayName: string;
  /** Email pre-filled when the owner self-fills a recipient row. */
  defaultEmail: string;
  /** Seeds the title of a newly created envelope. */
  defaultTitle: string;
  /** Seeds the recipient message of a newly created envelope. */
  defaultMessage: string;
  /**
   * When true, the first document uploaded to an untitled envelope appends
   * its filename to the title — e.g. "Complete with Fias: Service Agreement".
   */
  includeFilename: boolean;
}

export const DEFAULT_DOCUMENT_SIGN_SETTINGS: DocumentSignSettings = {
  defaultDisplayName: '',
  defaultEmail: '',
  defaultTitle: '',
  defaultMessage: '',
  includeFilename: false,
};

/**
 * Platform-wide fallback title applied when neither the user-configured
 * `defaultTitle` nor the on-screen title field has a value. Used at
 * envelope-create time AND at autosave time so an envelope is never left
 * with an empty title in the DB.
 */
export const PLATFORM_DEFAULT_ENVELOPE_TITLE = 'Document Signature Requested';

/**
 * Platform-wide fallback message — used as an actual default value the
 * user can keep or edit, NOT as a placeholder. Populated at create time
 * when the user has no `defaultMessage` setting; subsequent autosave
 * respects whatever the user has typed (including empty).
 */
export const PLATFORM_DEFAULT_ENVELOPE_MESSAGE =
  'Your signature is requested in the linked Document.';
